import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox"];

  selectWeekdays() {
    this.checkboxTargets.forEach((checkbox) => {
      if (checkbox.disabled) return;

      // data-date contains the day of week (0 = Sunday, 1 = Monday, etc.)
      const dayOfWeek = parseInt(checkbox.dataset.date, 10);
      // Select Mon-Fri (1-5), exclude Sat (6) and Sun (0)
      checkbox.checked = dayOfWeek >= 1 && dayOfWeek <= 5;
    });
  }

  selectAll() {
    this.checkboxTargets.forEach((checkbox) => {
      if (checkbox.disabled) return;
      checkbox.checked = true;
    });
  }

  clearAll() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = false;
    });
  }
}
